"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageAccount = ManageAccount;

var _react = _interopRequireWildcard(require("react"));

var _stripeJs = require("@stripe/stripe-js");

var _jquery = _interopRequireDefault(require("jquery"));

var _reactBootstrap = require("react-bootstrap");

var _components = require("../components");

var _functions = require("firebase/functions");

var _firebase = require("../firebase");

var _User = require("./User");

var _primitives = require("@bedrock-layout/primitives");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Config data is imported from .env files, to allow for development to use a testing server
var stripePromise = (0, _stripeJs.loadStripe)(process.env.REACT_APP_STRIPE_KEY);
var plans = JSON.parse(process.env.REACT_APP_STRIPE_PLANS);
var tosUrl = '/terms.html';
var privacyPolicyUrl = '/privacy.html';
var firebaseFunctions = (0, _functions.getFunctions)();
var createPartnerCheckout = (0, _functions.httpsCallable)(firebaseFunctions, 'createPartnerCheckout');
var declinePartnership = (0, _functions.httpsCallable)(firebaseFunctions, 'declinePartnership');
var getPartnershipStatus = (0, _functions.httpsCallable)(firebaseFunctions, 'getPartnershipStatus');
var manageBilling = (0, _functions.httpsCallable)(firebaseFunctions, 'createBillingManagementSession');

function ManageAccount(props) {
  var _user$profile, _user$profile2;

  var user = (0, _firebase.useAuth)();
  var priceRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var isSubscribed = user && ((_user$profile = user.profile) === null || _user$profile === void 0 ? void 0 : _user$profile.partnerSince) && !((_user$profile2 = user.profile) !== null && _user$profile2 !== void 0 && _user$profile2.freePartner);

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      partnerRate = _useState4[0],
      setPartnerRate = _useState4[1];

  (0, _react.useEffect)(function () {
    var nvm = false;

    if (user) {
      getPartnershipStatus().then(function (_ref) {
        var data = _ref.data;
        console.log({
          data: data
        });
        if (data.length > 1) console.warn("You seem to have multiple active subscriptions, is this correct?");

        if (data.length === 0) {
          // not subscribed
          if (partnerRate) setPartnerRate(0);
          return;
        }

        var subscription = data[0];
        console.log({
          subscription: subscription
        });
        var subItem = subscription.items.data[0];
        var partnerRate = subItem.quantity * subItem.price.unit_amount / 100;
        console.log({
          partnerRate: partnerRate
        });
        setPartnerRate(partnerRate);
      });
    }

    return function () {
      nvm = true;
    };
  }, [user.email, isSubscribed]);
  /**
   * Display Name & Email - later maybe change
   * Reset Password Button
   * 
   * if subscribed:
   *   Display amount subscribed
   *   Change amount button
   * 
   * not subscribed:
   *   Create partner same as create account 
  */

  function setErrorToDisplay(e) {
    console.error(e);
    var msg = e.message || e;
    setErrorMessage(msg);
  }

  function verifyAndCheckout(_x) {
    return _verifyAndCheckout.apply(this, arguments);
  }

  function _verifyAndCheckout() {
    _verifyAndCheckout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var price, sessionId, stripe;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              price = priceRef.current.value; // validate input

              if (!(price < 0)) {
                _context.next = 6;
                break;
              }

              setErrorToDisplay("Positive Numbers Only ;)");
              _context.next = 28;
              break;

            case 6:
              if (!(price > 0 && price < 0.50)) {
                _context.next = 10;
                break;
              }

              setErrorToDisplay("The minimum value is $0.50, due to processing fees. ");
              _context.next = 28;
              break;

            case 10:
              if (!(price == 0)) {
                _context.next = 16;
                break;
              }

              _context.next = 13;
              return declinePartnership();

            case 13:
              setErrorMessage("");
              _context.next = 28;
              break;

            case 16:
              if (!(price == '')) {
                _context.next = 20;
                break;
              }

              setErrorToDisplay("Please enter a partnership amount.");
              _context.next = 28;
              break;

            case 20:
              _context.next = 22;
              return createPartnerCheckout({
                price: price,
                success_url: window.location.origin,
                cancel_url: window.location.href
              });

            case 22:
              sessionId = _context.sent.data;
              _context.next = 25;
              return stripePromise;

            case 25:
              stripe = _context.sent;
              stripe.redirectToCheckout({
                sessionId: sessionId
              }).catch(function (e) {
                console.error(e.message);
              });
              setErrorMessage("");

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _verifyAndCheckout.apply(this, arguments);
  }

  function manageSubscription(_x2) {
    return _manageSubscription.apply(this, arguments);
  }

  function _manageSubscription() {
    _manageSubscription = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
      var session;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();
              _context2.next = 3;
              return manageBilling({
                return_url: window.location.href
              });

            case 3:
              session = _context2.sent.data;
              console.log(session);
              window.location = session.url;

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _manageSubscription.apply(this, arguments);
  }

  var notSubscribedMessage = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, (user === null || user === void 0 ? void 0 : user.displayName) || '', ","), /*#__PURE__*/_react.default.createElement("div", null, "We've invested so much in developing these high quality products to serve you guys. In order to follow Christ's lead in servitude, we are choosing to not fix a high price point, but rather to give our work freely in support of God's people. If you choose, please give back to us according to however God has blessed you."), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
    type: "number",
    "data-button": "round outline negative",
    name: "amount",
    placeholder: "$ Amount/Month",
    ref: priceRef,
    className: "form-control"
  }), /*#__PURE__*/_react.default.createElement("em", null, "Suggested $5/month subscription")), /*#__PURE__*/_react.default.createElement("button", {
    onClick: verifyAndCheckout,
    "data-button": "round outline negative",
    className: "btn",
    id: "submitAuth"
  }, "Next"), props.noSubscriptionYet && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: "center"
    },
    onClick: function onClick() {
      declinePartnership();
      setErrorMessage("");
    }
  }, "Not right now \u27F6"));

  var subscribedMessage = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, (user === null || user === void 0 ? void 0 : user.displayName) || '', ","), /*#__PURE__*/_react.default.createElement("div", null, "We've invested so much in developing these high quality products to serve you guys. In order to follow Christ's lead in servitude, we are choosing to not fix a high price point, but rather to give our work freely in support of God's people."), /*#__PURE__*/_react.default.createElement("div", null, "Currently, you are partering with us at $", partnerRate, ", but if you'd like to change that, you can do so below."), /*#__PURE__*/_react.default.createElement("button", {
    onClick: manageSubscription,
    "data-button": "round outline negative",
    className: "btn",
    id: "submitAuth"
  }, "Edit Partnership"), errorMessage && /*#__PURE__*/_react.default.createElement("div", {
    id: "errorMessage",
    "data-button": "round outline negative"
  }, errorMessage));

  return /*#__PURE__*/_react.default.createElement(_primitives.Split, {
    fraction: "2/3",
    style: {
      minHeight: "100vh",
      maxWidth: "60rem"
    }
  }, /*#__PURE__*/_react.default.createElement(_primitives.Cover, {
    className: "darkBackground",
    top: /*#__PURE__*/_react.default.createElement(_User.UserWidget, null)
  }, /*#__PURE__*/_react.default.createElement(_primitives.Stack, {
    as: "form",
    style: {
      gap: "1.5rem",
      padding: "5vw"
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, "Keep Up Your Memorization Journey!")), partnerRate ? subscribedMessage : notSubscribedMessage, errorMessage && /*#__PURE__*/_react.default.createElement("div", {
    id: "errorMessage",
    "data-button": "round outline negative"
  }, errorMessage), !props.noSubscriptionYet && /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick() {
      return window.location.pathname = "/";
    },
    className: "link "
  }, "\u27F5 Back to Memorizing"))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: "5vw"
    }
  }));
}